import AccordionTitle from '../../atoms/AccordionTitle';
import React, { Component } from 'react';
import AccordionButton from '../../atoms/AccordionButton';
import VideoBox from '../VideoBox/VideoBox';
import SimpleMarkdown from '../../atoms/SimpleMarkdown';
import classNames from 'classnames';
import './styles.css';

/**
 * AccordionItem
 *
 * @typedef {Object} Props
 * @prop {string}  question
 * @prop {Object}  answer
 *
 * @augments {Component<Props>}
 */
export default class AccordionItem extends Component {
	state = {
		isOpen: false,
	};

	/**
	 * @type {number}
	 */
	timeout;

	handleToggle = () => {
		this.setState(
			{
				isOpen: !this.state.isOpen,
			},
			() => {
				if (!this.accordionAnswerRef.current) return;

				window.clearTimeout(this.timeout); // Clear timeout in case user click faster than "animationDuration"
				const contentWrap = this.accordionAnswerRef.current;
				if (this.state.isOpen) {
					contentWrap.style.height = `${contentWrap.scrollHeight}px`;
					this.timeout = window.setTimeout(() => {
						contentWrap.style.height = 'auto';
					}, 3000);
				} else {
					contentWrap.style.height = `${contentWrap.scrollHeight}px`;
					this.timeout = window.setTimeout(() => {
						contentWrap.style.height = '0px';
					}, 0);
				}
			}
		);
	};

	accordionAnswerRef = React.createRef();

	genClassName = (state) =>
		classNames('AccordionItemAnswer', {
			AccordionItemAnswerOpen: state.isOpen,
		});

	render () {
		return (
			<div
				className={`AccordionItem ${
					this.state.isOpen ? 'AccordionItemOpen' : ''
				}`}
			>
				<div
					className={`AccordionItemWrap ${
						this.state.isOpen ? 'AccordionItemWrapOpen' : ''
					}`}
					onClick={this.handleToggle}
				>
					<AccordionTitle
						isOpen={this.state.isOpen}
						content={this.props.question}
					/>
					<AccordionButton isOpen={this.state.isOpen} />
				</div>
				<div
					ref={this.accordionAnswerRef}
					className={this.genClassName(this.state)}
				>
					<div className='listStyle'>
						<SimpleMarkdown extended>
							{this.props.answer.text}
						</SimpleMarkdown>
					</div>

					{this.props.answer.videos && this.props.answer.videos.map((videoId) => (
						<div className='videoBoxWrap' key={videoId}>
							<VideoBox
								isToggled={this.state.isOpen}
								type={this.props.answer.videoType}
								videoId={videoId}
							/>
						</div>
					)) }

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/AccordionItem/AccordionItem.js